import { render, staticRenderFns } from "./UnitAlertsCard.vue?vue&type=template&id=7463a0ca&"
import script from "./UnitAlertsCard.vue?vue&type=script&lang=js&"
export * from "./UnitAlertsCard.vue?vue&type=script&lang=js&"
import style0 from "./UnitAlertsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7463a0ca', component.options)
    } else {
      api.reload('7463a0ca', component.options)
    }
    module.hot.accept("./UnitAlertsCard.vue?vue&type=template&id=7463a0ca&", function () {
      api.rerender('7463a0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitAlertsCard.vue"
export default component.exports